import type { FC } from "react"
import { useTranslation } from "react-i18next"

import { NotFound } from "../../components"
import { Page } from "../../components/@shared/page"

interface Props {
	pageTile?: string
	title?: string | JSX.Element
	buttonText?: string
	to?: string
	image?: string
	state?: Collection<string, unknown>
}

export const NotFoundPage: FC<Props> = ({
	pageTile,
	title,
	state,
	image,
	buttonText,
	to = "/",
}) => {
	const [t] = useTranslation("common")
	const notFound = t("errors.genericNotFound", { returnObjects: true })

	return (
		<Page title={pageTile ?? notFound.pageTitle}>
			<NotFound
				to={to}
				image={image}
				state={state}
				title={title ?? notFound.title}
				buttonText={buttonText ?? notFound.buttonText}
			/>
		</Page>
	)
}

export default NotFoundPage
